import { ApiClient } from '@cnx-saas/common-fe';

const gatewayUrl = process.env.GRAPHQL_GATEWAY_URL ?? '';
const wssGatewayUrl = process.env.GRAPHQL_WS_GATEWAY_URL ?? '';

export const apiClient = ApiClient.create(gatewayUrl, undefined, wssGatewayUrl);
